import { atom } from 'jotai';

import type { EvidenceSelection } from '../lib/evidenceSelection';

export type DocumentDialogState = {
  eventId: string;
  docId: string;
  initialPages?: number[];
  highlightQuery?: string;
  /** Passage waarop het dialog opent: bepaalt scrollpositie, markering en het actieve resultaat. */
  initialEvidence?: EvidenceSelection;
} | null;

export const documentDialogAtom = atom<DocumentDialogState>(null);
